import './index.scss';
import { fetchJanusOabRedirectUrl } from 'utils/janus_oab_redirect';

const CTA_SELECTOR = '#cta-oab-freemium-damasio';

// Delegated handler: the modal markup is rendered by the layout, so we bind on
// `document` rather than the (possibly not-yet-present) button itself.
$(document).on('click', CTA_SELECTOR, async function (e) {
  e.preventDefault();

  const $cta = $(this);

  // Minting an SSO token + emitting analytics + navigating is not idempotent,
  // and the awaited fetch leaves a window where a second click would fire it
  // all again. Ignore re-clicks while a redirect is already in flight.
  if ($cta.data('redirecting')) {
    return;
  }
  $cta.data('redirecting', true);

  try {
    // Read via attr (not .data()): feedbacks.js writes this with .attr() at
    // runtime, and jQuery's .data() cache would return a stale value.
    const rawQuestionId = $cta.attr('data-question-id');
    const questionId = rawQuestionId ? Number(rawQuestionId) : null;
    const answer = $cta.attr('data-answer') || null;
    const sourceUrl = window.location.href;

    // Analytics must never block the redirect: a missing or broken tracker
    // only gets reported, the navigation below still happens.
    try {
      window.UserTracker.emit('event', {
        eventName: 'damasio redirect clicked',
        data: {
          'click source': 'questions limit modal',
          'question id': questionId,
          'question answer': answer,
          'source url': sourceUrl
        }
      });
    } catch (trackerErr) {
      Rollbar.error(
        'Erro ao emitir evento damasio redirect clicked',
        trackerErr
      );
    }

    const redirectUrl = await fetchJanusOabRedirectUrl(
      questionId,
      answer,
      sourceUrl
    );
    window.location.href = redirectUrl;
  } catch (err) {
    // Release the guard only on failure so the button recovers. After the
    // `location.href` assignment the page stays alive until the cross-origin
    // navigation completes, so on success the guard must stay set to keep
    // swallowing re-clicks (no double token mint / duplicate analytics).
    $cta.data('redirecting', false);
    Rollbar.error('Erro ao redirecionar para Janus OAB', err);
  }
});
